import { isMobile } from 'react-device-detect';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    justifyContent: 'space-between',
    padding: isMobile ? theme.spacing(1, 2) : undefined,
    paddingLeft: isMobile ? undefined : theme.spacing(2.1),
  },
  button: {
    display: 'flex',
    minWidth: 'max-content',
    marginLeft: !isMobile ? theme.spacing(5) : undefined,
    color: theme.palette.grey[50],
    '&:hover': {
      color: theme.palette.primary.main,
    },
    textTransform: 'none',
    textDecoration: 'none',
    borderRadius: theme.typography.button.borderRadius,
  },
  buttonAccount: {
    padding: theme.spacing(1.3, 1),
    background: 'linear-gradient(90deg, #26F7C5 0%, #8895FA 100%)',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      '&>.MuiTypography-root': {
        color: `${theme.palette.grey[900]} !important`,
      },
    },
    '&>.MuiTypography-root': {
      fontSize: '0.89rem !important',
    },
  },
  loginButton: {
    backgroundColor: theme.palette.grey[700],
    padding: theme.spacing(1.3, 1.8),
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.primary.main,
    },
  },

  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: theme.palette.grey[50],
    fontWeight: 'normal',
  },
}));

export default useStyles;
